import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=1a89a664&"
import script from "./messages.vue?vue&type=script&lang=js&"
export * from "./messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports